import type { RecordRef } from './types';

// Plan 4a, "Agent names on the wire".
const AGENT_NAMES: Record<string, string> = {
  assistant: 'Assistant',
  case: 'Case',
  ems: 'EMS Agent',
  ca: 'CA Agent',
  ca_lead: 'CA Lead Agent',
  compliance: 'Compliance Agent',
  mimir: 'Mimir (Engineering Agent)',
};

/** Display name for an agent id. Own-property lookup: the id comes off the wire, so "__proto__" must not resolve. */
export const agentLabel = (agent: string): string =>
  Object.prototype.hasOwnProperty.call(AGENT_NAMES, agent)
    ? AGENT_NAMES[agent]
    : agent;

/** A card's title: the label the service sends, else the built-in name. */
export const agentCardLabel = (agent: {
  name: string;
  label?: string;
}): string =>
  agent.label && agent.label !== agent.name
    ? agent.label
    : agentLabel(agent.name);

/** What the panel says when the agent API is not configured. The developer hint is for DEV builds only. */
export const offStateText = (
  isDev: boolean,
): { message: string; hint?: string } => ({
  message: "KALI AI isn't available yet.",
  ...(isDev && {
    hint: 'Set VITE_AGENT_API_URL to the odin-agents URL, or to mock in a development build.',
  }),
});

/** The chat message that asks for the crew (Plan 4a section 1); also "Run again". */
export const DRAFT_MESSAGE = 'Draft the application';

// The demo script's first question (spec §4, step 2).
const SUGGESTIONS = [
  "What's the applicant's income and what documents do we have?",
];
const NOTE_SUGGESTION = '@ca keep each note point under 12 words';

/**
 * The empty chat's suggestions: on an assessment only, since they ask about the
 * applicant and the crew needs one on screen (Plan 4a section 1). None on a
 * lender page or with no record.
 */
export const chatSuggestions = (ref: RecordRef | null): string[] =>
  ref?.type === 'assessment'
    ? [...SUGGESTIONS, DRAFT_MESSAGE, NOTE_SUGGESTION]
    : [];
